export function transformWikiContentHtml(html: string): string {
  if (!html) return ''

  // Wiki is a client-only SPA, but keep this safe if it ever runs in a non-DOM context.
  if (typeof DOMParser === 'undefined') return html

  try {
    const parser = new DOMParser()
    const doc = parser.parseFromString(html, 'text/html')

    const tables = Array.from(doc.querySelectorAll('table'))
    for (const table of tables) {
      const parent = table.parentElement
      if (parent?.classList.contains('wiki-table-wrap')) continue

      // Some editor exports add inline widths (or width attributes) that cause tables
      // to render narrow/cropped on mobile. Strip those so CSS can control sizing.
      table.removeAttribute('width')

      const style = table.getAttribute('style')
      if (style) {
        const cleaned = style
          .split(';')
          .map((rule) => rule.trim())
          .filter(Boolean)
          .filter((rule) => {
            const lower = rule.toLowerCase()
            return !(
              lower.startsWith('width:') ||
              lower.startsWith('min-width:') ||
              lower.startsWith('max-width:')
            )
          })
          .join('; ')

        if (cleaned) table.setAttribute('style', cleaned)
        else table.removeAttribute('style')
      }

      const wrap = doc.createElement('div')
      wrap.className = 'wiki-table-wrap'

      table.parentNode?.insertBefore(wrap, table)
      wrap.appendChild(table)
    }

    return doc.body.innerHTML
  } catch {
    return html
  }
}

